import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_DELETE_PROFILER_BEGIN,
  APP_SETTING_DELETE_PROFILER_SUCCESS,
  APP_SETTING_DELETE_PROFILER_FAILURE,
  APP_SETTING_DELETE_PROFILER_DISMISS_ERROR,
} from './constants';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteProfiler(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_DELETE_PROFILER_BEGIN,
    });
    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}profiler/delete`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_DELETE_PROFILER_SUCCESS,
            data: res,
          });
          resolve(res);
          toast.success('Deleted Successfully !', {});
        },
        (err) => {
          dispatch({
            type: APP_SETTING_DELETE_PROFILER_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Deletion Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteProfilerError() {
  return {
    type: APP_SETTING_DELETE_PROFILER_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_PROFILER_BEGIN:
      return {
        ...state,
        deleteProfilerPending: true,
        deleteProfilerError: null,
      };

    case APP_SETTING_DELETE_PROFILER_SUCCESS:
      return {
        ...state,
        deleteProfilerPending: false,
        deleteProfilerError: null,
      };

    case APP_SETTING_DELETE_PROFILER_FAILURE:
      return {
        ...state,
        deleteProfilerPending: false,
        deleteProfilerError: action.data.error,
      };

    case APP_SETTING_DELETE_PROFILER_DISMISS_ERROR:
      return {
        ...state,
        deleteProfilerError: null,
      };

    default:
      return state;
  }
}
